import { Box, LinearProgress, Typography } from '@material-ui/core';
import React from 'react';

export const CreatingAccountPrompt = () => {
  return (
    <>
      <LinearProgress color='primary' />
      <Box mx={10} my={4}>
        <Typography variant='h4' style={{ textAlign: 'center' }}>
          Hold Tight
        </Typography>
        <Typography variant='h6' style={{ textAlign: 'center' }}>
          We are creating your account
        </Typography>
        <Typography variant='body2' color='textSecondary' style={{ marginTop: '16px', textAlign: 'center' }}>
          This page will refresh in a couple of seconds. Do not close or navigate away from this page.
        </Typography>
      </Box>
    </>
  );
};
